import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/warnerror.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", {
  class: "modal-title",
  id: "assignaddontitle"
}, "REMOVE ADD-ONS", -1)
const _hoisted_2 = {
  key: 0,
  class: "modalbody"
}
const _hoisted_3 = { class: "datadiv bottommargin" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "headerfont" }, " Select add-ons to remove ", -1)
const _hoisted_5 = { class: "overflowdiv topmargin" }
const _hoisted_6 = { class: "prodnamediv" }
const _hoisted_7 = { style: {"text-align":"start"} }
const _hoisted_8 = {
  class: "font-bold",
  style: {"font-size":"14px","line-height":"19.07px"}
}
const _hoisted_9 = {
  key: 1,
  class: "buttonsdiv"
}
const _hoisted_10 = {
  key: 0,
  class: "fa fa-refresh fa-spin"
}
const _hoisted_11 = {
  key: 2,
  class: "modalbody"
}
const _hoisted_12 = {
  key: 0,
  class: "font-bold-16"
}
const _hoisted_13 = { class: "font-regular-16 btm-1" }
const _hoisted_14 = { class: "userlistdiv" }
const _hoisted_15 = { class: "font-regular-16 breaking-words" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "btm-2" }, "Below errors occured for the selected users:", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle btm-1" }, "User Name: ", -1)
const _hoisted_19 = { class: "font-bold-16 btm-1" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle btm-1" }, "Addons Name: ", -1)
const _hoisted_21 = { class: "font-bold-16 btm-1" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "summarytitle btm-1" }, "Version: ", -1)
const _hoisted_24 = { class: "btm-2" }
const _hoisted_25 = {
  key: 0,
  style: {"display":"flex"},
  class: "maxitems"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "cellimage",
  style: {"margin-top":"10px"},
  alt: "errorimg",
  title: "errorimg"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  class: "errordiv",
  style: {"padding":"1rem 0"}
}, " Error occured during removal of add-ons.", -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { class: "buttonsdiv" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (!_ctx.removalDone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_table, {
                id: "prodtoassigntable",
                data: _ctx.userAddonsList,
                border: true,
                style: {"width":"100%"},
                "row-style": _ctx.rowdatastyle,
                onSelectionChange: _ctx.handleCurrentChange,
                "show-header": false,
                "empty-text": "No add-ons to remove"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    type: "selection",
                    width: "50"
                  }),
                  _createVNode(_component_el_table_column, { "min-width": "230" }, {
                    default: _withCtx((props) => [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("h6", _hoisted_8, _toDisplayString(props.row.productName), 1),
                          _createElementVNode("label", null, " Version: " + _toDisplayString(props.row.majorVersionNumber) + "." + _toDisplayString(props.row.minorVersionNumber), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "row-style", "onSelectionChange"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.removalDone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_el_button, {
            id: "assignaddonnext",
            round: "",
            class: "btnstyle ml-4",
            variant: "warning",
            onClick: _ctx.removeSelectedAddons,
            disabled: !_ctx.enableNext
          }, {
            default: _withCtx(() => [
              (!_ctx.enableNext && !_ctx.showError)
                ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                : _createCommentVNode("", true),
              _createTextVNode(" Continue ")
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createVNode(_component_el_button, {
            id: "prodassigncancel",
            round: "",
            variant: "outline-dark",
            onClick: _ctx.cancelRemoval,
            class: "cancelbtn"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.removalDone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_ctx.removeSuccess)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedAddonsList, (addon, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "addonlistdiv"
                  }, [
                    _createElementVNode("label", _hoisted_13, [
                      _createTextVNode(" Add-on \""),
                      _createElementVNode("strong", null, _toDisplayString(addon.productName), 1),
                      _createTextVNode("\" has been removed successfully from the users below: ")
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.successUsers, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          _createElementVNode("label", _hoisted_15, _toDisplayString(item.userName) + ", " + _toDisplayString(item.userEmail), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.showError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _hoisted_17,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorsList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "font-bold-16 btm-1"
                  }, [
                    _hoisted_18,
                    _createElementVNode("label", _hoisted_19, _toDisplayString(item.errorUser), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.errorProducts, (prod, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "font-bold-16 btm-1"
                      }, [
                        _hoisted_20,
                        _createElementVNode("label", _hoisted_21, _toDisplayString(prod.productName), 1),
                        _hoisted_22,
                        _hoisted_23,
                        _createElementVNode("label", _hoisted_24, _toDisplayString(prod.majorVersionNumber) + "." + _toDisplayString(prod.minorVersionNumber), 1)
                      ]))
                    }), 128)),
                    (_ctx.showError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_28))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_el_button, {
              round: "",
              class: "btnstyle ml-4",
              variant: "warning",
              id: "prodassingconfirm",
              onClick: _ctx.cancelRemoval
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Done ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}